import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';
import { TUserGroupsState } from './types';

export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  state: {
    areas: [],
    countries: [],
    areaCountryLinks: [],
    customsItems: [],
    transportGroups: [],
    transportItems: [],
    goodsGroups: [],
    goodsItems: [],
    goodsUnits: [],
  } as TUserGroupsState,
};
